import { Routes, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@riise/core/services/auth/auth.service';
import { ContentComponent } from '@riise/shared/components/layout/content/content.component';



const customAuthGuard = () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  if (authService.isLoggedIn) {
    return true;
  }
  router.navigate(['auth/login']);
  return false;
};

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then(m => m.AUTH_ROUTES),
  },
  {
    path: '',
    component: ContentComponent,
    canActivate: [customAuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./features/dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES),
      },
      {
        path: 'insurers',
        loadChildren: () => import('./features/insurers/insurers.routes').then(m => m.INSURERS_ROUTES),
      },
      {
        path: 'producers',
        loadChildren: () => import('./features/producers/producers.routes').then(m => m.PRODUCERS_ROUTES),
      },
      {
        path: 'directors',
        loadChildren: () => import('./features/directors/directors.routes').then(m => m.DIRECTORS_ROUTES),
      },
      {
        path: 'commissions',
        loadChildren: () => import('./features/commissions/commissions.routes').then(m => m.COMMISSIONS_ROUTES),
      },
      {
        path: 'payments',
        loadChildren: () => import('./features/payments/payments.routes').then(m => m.PAYMENTS_ROUTES),
      },
      {
        path: 'top-ups',
        loadChildren: () => import('./features/top-ups/top-ups.routes').then(m => m.TOP_UPS_ROUTES),
      },
      {
        path: 'providers',
        loadChildren: () => import('./features/providers/providers.routes').then(m => m.PROVIDERS_ROUTES),
      },
      {
        path: 'clients',
        loadChildren: () => import('./features/clients/clients.routes').then(m => m.CLIENTS_ROUTES),
      },
      {
        path: 'leads',
        loadChildren: () => import('./features/leads/leads.routes').then(m => m.LEADS_ROUTES),
      },
      {
        path: 'opportunities',
        loadChildren: () => import('./features/opportunities/opportunities.routes').then(m => m.OPPORTUNITIES_ROUTES),
      },
      {
        path: 'quotations',
        loadChildren: () => import('./features/quotation/quotation.routes').then(m => m.QUOTATION_ROUTES),
      },

      {
        path: 'contracts',
        loadChildren: () => import('./features/contracts/contracts.routes').then(m => m.CONTRACTS_ROUTES),
      },
      {
        path: 'sinisters',
        loadChildren: () => import('./features/sinisters/sinisters.routes').then(m => m.SINISTERS_ROUTES),
      },
      {
        path: 'statistics',
        loadChildren: () => import('./features/statistics/statistics.routes').then(m => m.STATISTICS_ROUTES),
      },
      {
        path: 'notifications',
        loadChildren: () => import('./features/notifications/notifications.routes').then(m => m.NOTIFICATIONS_ROUTES),
      },
      {
        path: 'exercices',
        loadChildren: () => import('./features/exercices/exercices.routes').then(m => m.EXERCICES_ROUTES),
      },
      {
        path: 'requests',
        loadChildren: () => import('./features/requests/requests.routes').then(m => m.REQUESTS_ROUTES),
      },
      {
        path: 'agreements',
        loadChildren: () => import('./features/agreements/agreements.routes').then(m => m.AGREEMENTS_ROUTES),
      },
      {
        path: 'categories',
        loadChildren: () => import('./features/categories/categories.routes').then(m => m.CATEGORIES_ROUTES),
      },
      {
        path: 'branches',
        loadChildren: () => import('./features/branches/branches.routes').then(m => m.BRANCHES_ROUTES),
      },
      {
        path: 'formulas', 
        loadChildren: () => import('./features/formulas/formulas.routes').then(m => m.FORMULAS_ROUTES),
      },
      {
        path: 'feedback',
        loadChildren: () => import('./features/feedback/feedback.routes').then(m => m.FEEDBACK_ROUTES),
      },
      {
        path: 'profile',
        loadChildren: () => import('./features/profile/profile.routes').then(m => m.PROFILE_ROUTES),
      },
      {
        path: 'privacy',
        loadChildren: () => import('./features/privacy/privacy.routes').then(m => m.PRIVACY_ROUTES),
      },
      {
        path: 'parameters',
        loadChildren: () => import('./features/parameters/parameters.routes').then(m => m.PARAMETERS_ROUTES),
      },
      {
        path: 'users',
        loadChildren: () => import('./features/users/users.routes').then(m => m.USERS_ROUTES),
      },
      {
        path: 'vehicles',
        loadChildren: () => import('./features/vehicles-brands/vehicles-brands.routes').then(m => m.VEHICLES_BRANDS_ROUTES),
      },
      {
        path: 'all-vehicles',
        loadChildren: () => import('./features/vehicles/vehicles.routes').then(m => m.VEHICLES_ROUTES),
      },
      {
        path: 'transactions',
        loadChildren: () => import('./features/transactions/transactions.routes').then(m => m.TRANSACTIONS_ROUTES),
      },
    ]
  },
  {
    path: 'error',
    loadChildren: () => import('./features/error-page/error-page.routes').then(m => m.ERROR_PAGE_ROUTES),
  },
  {
    path: 'privacy',
    loadChildren: () => import('./features/privacy/privacy.routes').then(m => m.PRIVACY_ROUTES),
  },
  {
    path: '**',
    redirectTo: '/error?status=404'
  }
];
